// Module
var code = `<template>
  <require from="./top-bottom-instruments-light-widget.scss"></require>

  <!-- beautify ignore:start -->
  <style if.bind="rowHeight">
    .top-bottom-instruments-light-widget-\${id} tr {
      height: \${rowHeight}px !important;
    }
  </style>

  <style>
    .top-bottom-instruments-light-widget-\${id} {
      font-family: \${font || 'var(--dyn-default-font-family)'};
      font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
      color: \${color | widgetTemplateColor:isInDashboard} !important;
    }

    .top-bottom-instruments-light-widget-\${id} th {
      font-family: \${captionFont ? captionFont : 'var(--dyn-default-font-family)'};
      font-size: \${captionFontSize ? captionFontSize + 'px' : 'var(--dyn-default-font-size)'};
      color: \${captionColor | widgetTemplateColor:isInDashboard} !important;
    }
  </style>
  <!-- beautify ignore:end -->

  <div class="top-bottom-instruments-light-widget top-bottom-instruments-light-widget-\${id}">
    <mdc-circular-progress if.bind="loading"></mdc-circular-progress>

    <table if.bind="!loading && !error" class="widget-table">
      <thead>
        <tr>
          <th>Instrument</th>
          <th class="widget-table__numeric">Value</th>
          <th class="widget-table__numeric">Share</th>
          <th class="widget-table__numeric">
            \${startFrom === TopBottomInstrumentsWidgetStartFrom.ToDateYearStart ?'P&L YTD' : 'P&L'}</th>
          <th class="widget-table__numeric">
            \${startFrom === TopBottomInstrumentsWidgetStartFrom.ToDateYearStart ? 'P&L YTD in %' : 'P&L in %'}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr repeat.for="v of instruments" class="\${v === total ? 'widget-table__total' : ''}">
          <td>\${v[nameField]}</td>
          <td class="widget-table__numeric">\${v.estimatedValueClosingBalance | numericFormatter:precision}</td>
          <td class="widget-table__numeric">\${v.estimatedValuePercent | numericFormatter:precision}</td>
          <template if.bind="startFrom === TopBottomInstrumentsWidgetStartFrom.ToDateYearStart">
            <td class="widget-table__numeric">\${v.profitLossChangeYearToDate | numericFormatter:precision}</td>
            <td class="widget-table__numeric">\${v.profitLossChangeYearToDateInPercent * 100 | numericFormatter:precision}
            </td>
          </template>
          <template else>
            <td class="widget-table__numeric">\${v.profitLossChangeInPeriod | numericFormatter:precision}</td>
            <td class="widget-table__numeric">\${v.profitLossChangePeriodInPercent * 100 | numericFormatter:precision}</td>
          </template>
        </tr>
      </tbody>
    </table>

    <message if.bind="error" class="widget__error" icon="error" colour="mdc-theme--error">
      \${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;